const routes = [
  {
    path: '',
    name: 'ro.retailer.dashboard',
    component: () => import('@/views/retailer/dashboard/dashboard.vue'),
    meta: {
      breadcrumb: { name: 'Pagina principala' }
    }
  },
  {
    path: 'applications/channels',
    name: 'ro.retailer.applications.channels',
    component: () => import('@/views/retailer/applications/international/romania/channels.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Tip Fermier' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/create',
    name: 'ro.retailer.applications.create',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/create.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Vanzare Noua' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/:id/farmer-info',
    name: 'ro.retailer.applications.farmer-info',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/farmerInfo.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Informatii Fermier' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/:id/documents',
    name: 'ro.retailer.applications.documents',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/documents.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Documents' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/:id/survey',
    name: 'ro.retailer.applications.survey',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/survey.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Survey' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/:id/decision',
    name: 'ro.retailer.applications.decision',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/decision.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Decision' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  },
  {
    path: 'applications/:id/complete',
    name: 'ro.retailer.applications.complete',
    component: () => import('@/views/retailer/applications/international/romania/privateIndividual/complete.vue'),
    props: true,
    meta: {
      breadcrumb: { name: 'Finalizat' }
    },
    beforeEnter: (to, from, next) => {
      next({
        name: 'retailer.information'
      })
    }
  }
]

export default routes
